var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceivableNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6245 10.3125C15.6245 9.79472 15.1952 9.375 14.6656 9.375H4.78898C4.25938 9.375 3.83008 9.79472 3.83008 10.3125C3.83008 10.8303 4.25938 11.25 4.78898 11.25H14.6656C15.1952 11.25 15.6245 10.8303 15.6245 10.3125Z",
    fill: "#51566D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.78898 13.125C4.25938 13.125 3.83008 13.5447 3.83008 14.0625C3.83008 14.5803 4.25938 15 4.78898 15H10.7874C11.317 15 11.7463 14.5803 11.7463 14.0625C11.7463 13.5447 11.317 13.125 10.7874 13.125H4.78898Z",
    fill: "#51566D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.04257 22.125H3.83559C2.77812 22.125 1.91779 21.2839 1.91779 20.25V3.75C1.91779 2.71613 2.77812 1.875 3.83559 1.875H15.6247C16.6822 1.875 17.5425 2.71613 17.5425 3.75V9.51562C17.5425 10.0334 17.9718 10.4531 18.5014 10.4531C19.031 10.4531 19.4603 10.0334 19.4603 9.51562V3.75C19.4603 1.68225 17.7396 0 15.6247 0H3.83559C1.72065 0 0 1.68225 0 3.75V20.25C0 22.3177 1.72065 24 3.83559 24H7.04257C7.57217 24 8.00147 23.5803 8.00147 23.0625C8.00147 22.5447 7.57217 22.125 7.04257 22.125Z",
    fill: "#51566D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.1586 13.5735C20.0369 12.4769 18.212 12.4769 17.0911 13.5728L11.8266 18.7084C11.7148 18.8175 11.6323 18.9518 11.5864 19.0996L10.4399 22.7898C10.3382 23.117 10.4268 23.4723 10.671 23.717C10.854 23.9003 11.1025 23.9998 11.3574 23.9998C11.4427 23.9998 11.5288 23.9887 11.6134 23.9658L15.4837 22.9176C15.643 22.8745 15.7882 22.7918 15.9051 22.6776L21.1586 17.5511C22.2802 16.4545 22.2802 14.6702 21.1586 13.5735ZM14.7288 21.1765L12.7816 21.7038L13.3515 19.8696L16.9036 16.4044L18.26 17.7305L14.7288 21.1765ZM19.8032 16.2247L19.6174 16.406L18.2613 15.0801L18.4465 14.8994C18.8203 14.5339 19.4287 14.5339 19.8025 14.8994C20.1764 15.265 20.1764 15.8597 19.8032 16.2247Z",
    fill: "#51566D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.6656 5.625H4.78898C4.25938 5.625 3.83008 6.04472 3.83008 6.5625C3.83008 7.08028 4.25938 7.5 4.78898 7.5H14.6656C15.1952 7.5 15.6245 7.08028 15.6245 6.5625C15.6245 6.04472 15.1952 5.625 14.6656 5.625Z",
    fill: "#51566D"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivableNotes);
export default __webpack_public_path__ + "static/media/receivableNotes.26b4f753cad0bb0fa2ef2012862edfc7.svg";
export { ForwardRef as ReactComponent };